import React, { forwardRef, ReactNode } from "react";
import "./Button.css";

type ButtonProps = {
  children: ReactNode;
  className?: string;
  onClick?: any;
  type?: "submit" | "reset" | "button" | undefined;
  disabled?: boolean;
};

export const ThemedPrimaryButton = forwardRef(
  ({ children, className, ...props }: ButtonProps, ref) => {
    const primaryClass = "themedPrimaryButton baseStyles";
    return (
      <button
        className={className ? `${className} ${primaryClass}` : primaryClass}
        {...props}
      >
        {children}
      </button>
    );
  }
);

export const ThemedSecondaryButton = forwardRef(
  ({ children, className, ...props }: ButtonProps, ref) => {
    const secondaryClass = "themedSecondaryButton baseStyles";
    return (
      <button
        className={
          className ? `${className} ${secondaryClass}` : secondaryClass
        }
        {...props}
      >
        {children}
      </button>
    );
  }
);

export const ThemedIconButton = forwardRef(
  ({ children, className, ...props }: ButtonProps, ref) => {
    return (
      <button
        className={className ? `${className} IconButton` : "IconButton"}
        {...props}
      >
        {children}
      </button>
    );
  }
);
